module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"defaultLanguage":"de-DE","i18nextOptions":{"interpolation":{"escapeValue":false},"keySeparator":false,"nsSeparator":false,"redirect":true},"languages":["de-DE","en-GB"],"localeJsonSourceName":"locale","pages":[{"getLanguageFromPath":true,"matchPath":["/:lang?","/:lang?/(.*)"]}],"siteUrl":"https://www.kunstmuseum-gelsenkirchen.de","trailingSlash":"never"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"background_color":"#ffffff","display":"standalone","icon":"src/images/favicons/favicon-512.png","include_favicon":false,"legacy":false,"name":"Kunstmuseum Gelsenkirchen","start_url":"/","theme_color":"#ffffff","theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"f6310f3a4c61ab5f959f8d3c43fcd641"},
    },{
      plugin: require('../node_modules/gatsby-plugin-smoothscroll/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
